export const THEME_CONSTANTS = {
  SPACING: 8
}
